// extracted by mini-css-extract-plugin
export default {"container":"UserThumbnail_container__cSY5N","wrapper":"UserThumbnail_wrapper__dBYO7"};